import { CheckCircle2, Briefcase, Search, MessageCircle, Star, CreditCard } from 'lucide-react';

const FeatureSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">How SEO Link Market Works</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A seamless platform connecting link buyers with verified sellers through a transparent marketplace
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <Briefcase size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Seller Profiles</h3>
            <p className="text-gray-600">
              Create your seller profile, list your link offers, and build your reputation with verified reviews.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <Search size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Buyer Request Board</h3>
            <p className="text-gray-600">
              Post what you're looking for and receive tailored offers from relevant sellers.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <CheckCircle2 size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Quality Links</h3>
            <p className="text-gray-600">
              Browse offers with transparent metrics: DR/DA scores, traffic estimates, and link types.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <MessageCircle size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Contextual Messaging</h3>
            <p className="text-gray-600">
              Communicate directly with buyers or sellers about specific offers or requests.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <Star size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Reviews & Trust</h3>
            <p className="text-gray-600">
              Leave and read verified reviews to build trust within our marketplace community.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="mb-4 text-brand-purple">
              <CreditCard size={36} />
            </div>
            <h3 className="text-xl font-semibold mb-3">Secure Payments</h3>
            <p className="text-gray-600">
              Optional Stripe Connect integration for secure, direct payments to sellers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
